<template>
    <inter-table
            :showFilters="true"
            :fields="fields"
            :filters="filters"
            action="requests-archive"
            :archive="isArchived"
    >

        <template v-slot:cell(society)="data">
            <div class="text-uppercase text-primary text-truncate">
                {{data.item.user.data.society}}
            </div>
            <div class="small text-uppercase text-truncate">
                {{data.item.user.surname}} {{data.item.user.name}}
            </div>
        </template>

        <template v-slot:cell(opponent)="data">
            <div class="text-uppercase text-primary text-truncate">
                {{data.item.match.opponent}}
            </div>
            <div class="small text-uppercase text-truncate">
                {{data.item.match.date | date}}
            </div>
        </template>

        <template v-slot:cell(status)="data">
            <b-badge :variant="requestStatuses[data.item.status].variant" class="text-uppercase">
                {{requestStatuses[data.item.status].label}}
            </b-badge>
            <admin-request-status
                    :tickets="data.item.media.length > 0"
                    class="mt-2"
                    :status="data.item.status"></admin-request-status>
        </template>

        <template v-slot:cell(sector)="data">
            <b-card no-body>
                <b-card-header class="p-1 text-center small">{{data.item.sector.code}}</b-card-header>
                <div class="p-1 text-center small">{{data.item.details.length}}</div>
            </b-card>
        </template>

        <template v-slot:cell(amount)="data">
            <b-card no-body
                    :border-variant="requestPayment[data.item.payment_method].variant">
                <b-card-header :header-bg-variant="requestPayment[data.item.payment_method].variant"
                               class=" small text-uppercase p-1 text-center text-white">
                    {{requestPayment[data.item.payment_method].label}}
                </b-card-header>
                <div class="p-1 text-center small">{{data.item.amount | currency}}</div>
            </b-card>
        </template>

        <template v-slot:cell(date)="data">
            {{data.item.created_at | date}}
        </template>

        <template v-slot:cell(action)="data">
            <div class="d-flex justify-content-end">
                <inter-table-button
                        icon="flaticon-open-folder"
                        @onClick="$emit('onShow', data.item)"
                >
                </inter-table-button>
            </div>
        </template>

        <template slot="custom-filters">
            <b-col cols="12" md="4" class="mb-3">
                <inter-select
                        placeholder="Partita"
                        v-model="filters.match"
                        asyncFindAction="select/matches-archive"
                        :archive="isArchived"
                ></inter-select>
            </b-col>
            <b-col cols="12" md="4" class="mb-3">
                <inter-select
                        asyncFindAction="select/societies"
                        placeholder="Società"
                        v-model="filters.society"
                ></inter-select>
            </b-col>
            <b-col cols="12" md="4" class="mb-3">
                <inter-select
                        placeholder="Stato"
                        v-model="filters.status"
                        :options="selectStatusOptions"
                ></inter-select>
            </b-col>


        </template>



    </inter-table>
</template>

<script>
    import InterTable from "../../../components/table/InterTable";
    import InterTableButton from "../../../components/table/InterTableButton";
    import InterSelect from "../../../components/form/inter-select/InterSelect";
    import _ from 'lodash';
    import Utils from '@/utils'
    import AdminRequestStatus from "./admin-request-status/AdminRequestStatus";

    export default {
        name: "AdminRequestsTable",
        components: {AdminRequestStatus, InterSelect, InterTableButton, InterTable},
        data() {
            return {
                isArchived: true,
                filters: {},
                requestStatuses: Utils.getRequestStatuses(),
                requestPayment: {
                    bonifico: {variant: 'primary', label: 'Bonifico'},
                    cc: {variant: 'secondary', label: 'Carta di credito'},
                },
                fields: [
                    {key: 'date', label: 'Data', class: 'text-center'},
                    {key: 'society', label: 'Società', class: 'text-left'},
                    {key: 'opponent', label: 'Partita', class: 'text-center'},
                    {key: 'sector', label: 'Posti', class: 'text-center'},
                    {key: 'status', label: 'Stato', class: 'text-center'},
                    {key: 'amount', label: 'Importo', class: 'text-center'},
                    {key: 'action', label: ''},
                ],
                matches: []
            }
        },
        computed: {
            selectStatusOptions: function () {
                return _.map(this.requestStatuses, (item, index) => {
                    return {
                        name: item.label.toUpperCase(),
                        value: index
                    }
                })
            },
        },
        mounted() {

        },
        methods: {

        }
    }
</script>

<style scoped>

</style>
